import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from 'components/shared-components/Loading';
import { PUBLIC_PREFIX_PATH } from 'configs/AppConfig'
let dataEscuela =  JSON.parse(localStorage.getItem('dataEscuela')); 

export const AppViews = () => {
  return (
    <Suspense fallback={<Loading cover="page"/>}>
      <Switch>
        <Route path={`${PUBLIC_PREFIX_PATH}/demo`} component={lazy(() => import(`./demo/index`))} />
        <Route path={`${PUBLIC_PREFIX_PATH}/admision/:idAdmision`} component={lazy(() => import(`./admision/index`))} />

      </Switch>
    </Suspense>
  )
}

export default AppViews;

